import { render, staticRenderFns } from "./GridTableFull.vue?vue&type=template&id=2dbfd94b&scoped=true"
import script from "./GridTableFull.vue?vue&type=script&lang=js"
export * from "./GridTableFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbfd94b",
  null
  
)

export default component.exports